module.exports = __webpack_public_path__ + "img/goTop.8a77cea.png";